import AdminCreation from "../../modules/administration/AdminCreation.vue";

const routes = [
    { 
        path: '/administrateurs', 
        component: AdminCreation 
    },
];

export default routes;